// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import "moment/locale/es";
import Datepicker from "vuejs-datepicker";
import VeeValidate from "vee-validate";
import VueToastr from "@deveodk/vue-toastr";
import VueStash from "vue-stash";
import Loading from "vue-loading-overlay";
import VueScrollReveal from "vue-scroll-reveal";
import "vue-loading-overlay/dist/vue-loading.min.css";
import store from "./config/store";
import App from "./App.vue";
import router from "./config/router";
import Auth from "./config/auth.js";
import axios from "./config/axios.js";
import "./config/filtros.js";
import "./components/comunes";

const pkg = require("../package.json").name;

Vue.config.productionTip = false;

Vue.use(VueToastr);
Vue.use(VeeValidate);
Vue.use(Auth, axios, { pkg });
Vue.use(VueStash);
Vue.use(Loading);
Vue.use(VueScrollReveal, {
  duration: 1200,
  scale: 0.85,
  opacity: 0,
  distance: "3em",
  mobile: true,
  viewFactor: 0.35,
});

Vue.component("datepicker", Datepicker);

Vue.prototype.$auth.autenticar();
Vue.prototype.$eventBus = new Vue();

/* eslint-disable no-new */
export default new Vue({
  el: "#app",
  router,
  components: { App },
  data: {
    store,
  },
  render(createElem) {
    return createElem("App");
  },
});



// WEBPACK FOOTER //
// ./src/main.js